import 'src/component/BillingConfiguration/style.scss'
import { useContext, useEffect, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import { SidePopupContainer, FlexColumn, FlexRow, AppSpan, Button, Form, FormGroup, ReactSelect } from "src/style"
import { RiCloseFill } from "react-icons/ri"
import utility from "src/utils/utility"
import { components } from "react-select"
import { ReactComponent as InstitutionFillIcon } from 'src/assets/img/institution-fill-icon.svg'
import { Institution } from "src/model"
import { useNotifier } from "react-pop-notifier"

export const CreateInstitutionBillingConfig: React.FC<any> = ({product, config, getUpdatedConfigs, close}) => {
    const {API} = useContext(ApiContext)
    const {notifier} = useNotifier()
    const [input, setInput] = useState<any>({
        monthlyFee: '', activeUsersFee: '', 
        totalUsersFee: '', activeBackendUsersFee: '', 
        totalBackendUsersFee: '', institutionCode: null
    })
    const [institutions, setInstitutions] = useState<Array<Institution> | null>(null)

    const { Option } = components;
    const IconOption = (props: any) => (
        <Option {...props}>
            <InstitutionFillIcon style={{ marginRight: '1.5rem' }} />
            {props.data.label}
        </Option>
    );

    useEffect(() => {
        if (config) {
            const { 
                monthlyFee, activeUsersFee, 
                totalUsersFee, activeBackendUsersFee, 
                totalBackendUsersFee, institutionCode
            } = config

            setInput({
                ...input,
                monthlyFee, activeUsersFee,
                totalUsersFee, activeBackendUsersFee,
                totalBackendUsersFee, institutionCode
            })
        }
    }, [])

    useEffect(() => {
        handleFetchInstitutions()
    }, [])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleFetchInstitutions() {
        const response = await API.getAllInstitutionV2()
        if (response) setInstitutions(response)
    }

    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        if (!input.institutionCode) return notifier.show('Kindly select Institution', 'Validation Response')

        const payload = {
            ...input,
            productId: product.id
        }

        const response = config ? await API.updateInstitutionProductBillingConfig(config.id, payload)
           : await API.createInstitutionProductBillingConfig(payload)
        
           if (response) {
            if (getUpdatedConfigs) getUpdatedConfigs()
            close()
        }
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="new-billing-config"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">
                        Create New Institution Configuration
                    </AppSpan>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </FlexRow>
                <Form topMargin="2" onSubmit={handleSubmit}>
                    { !config &&
                        <ReactSelect
                            styles={utility.reactSelectStyles()}
                            options={
                                institutions?.map((item: any, index: number) => {
                                    return {
                                        label: item.name,
                                        value: item.code,
                                        key: index
                                    }
                                })
                            }
                            isClearable={true}
                            isSearchable={true}
                            name='institution'
                            placeholder="Select Institution"
                            menuPortalTarget={document.body}
                            value={input.institution}
                            onChange={(val: any) => setInput({ ...input, institutionCode: val?.value })}
                            components={{ Option: IconOption }}
                        />
                    }
                    <FlexRow 
                        justifyContent="space-between" 
                        gap="1.5" wrap="wrap"
                        topMargin="2"
                    >
                        <AppSpan color="#344054" fontWeight='500'>Flat fee</AppSpan>
                        <FormGroup 
                            style={{width: '30rem'}}
                            bottomMargin="0"
                        >
                            <input 
                                placeholder="Enter fee here" 
                                name='monthlyFee'
                                type='number'
                                value={input.monthlyFee}
                                onChange={handleInput}
                                autoComplete='off'
                                required
                            />
                        </FormGroup>
                    </FlexRow>
                    <FlexRow 
                        justifyContent="space-between" 
                        gap="1.5" wrap="wrap"
                        topMargin="2"
                    >
                        <AppSpan color="#344054" fontWeight='500'>Active users fee (per user)</AppSpan>
                        <FormGroup 
                            style={{width: '30rem'}}
                            bottomMargin="0"
                        >
                            <input 
                                placeholder="Enter fee here" 
                                name='activeUsersFee'
                                type='number'
                                value={input.activeUsersFee}
                                onChange={handleInput}
                                autoComplete='off'
                                required
                            />
                        </FormGroup>
                    </FlexRow>
                    <FlexRow 
                        justifyContent="space-between" 
                        gap="1.5" wrap="wrap"
                        topMargin="2"
                    >
                        <AppSpan color="#344054" fontWeight='500'>Total users fee (per user)</AppSpan>
                        <FormGroup 
                            style={{width: '30rem'}}
                            bottomMargin="0"
                        >
                            <input 
                                placeholder="Enter fee here" 
                                name='totalUsersFee'
                                type='number'
                                value={input.totalUsersFee}
                                onChange={handleInput}
                                autoComplete='off'
                                required
                            />
                        </FormGroup>
                    </FlexRow>
                    <FlexRow 
                        justifyContent="space-between" 
                        gap="1.5" wrap="wrap"
                        topMargin="2"
                    >
                        <AppSpan color="#344054" fontWeight='500'>Active backend users fee (per user)</AppSpan>
                        <FormGroup 
                            style={{width: '30rem'}}
                            bottomMargin="0"
                        >
                            <input 
                                placeholder="Enter fee here" 
                                name='activeBackendUsersFee'
                                type='number'
                                value={input.activeBackendUsersFee}
                                onChange={handleInput}
                                autoComplete='off'
                                required
                            />
                        </FormGroup>
                    </FlexRow>
                    <FlexRow 
                        justifyContent="space-between" 
                        gap="1.5" wrap="wrap"
                        topMargin="2"
                    >
                        <AppSpan color="#344054" fontWeight='500'>Total backend users fee (per user)</AppSpan>
                        <FormGroup 
                            style={{width: '30rem'}}
                            bottomMargin="0"
                        >
                            <input 
                                placeholder="Enter fee here" 
                                name='totalBackendUsersFee'
                                type='number'
                                value={input.totalBackendUsersFee}
                                onChange={handleInput}
                                autoComplete='off'
                                required
                            />
                        </FormGroup>
                    </FlexRow>

                    <FlexRow justifyContent="flex-end" topMargin='2'>
                        <Button
                            width='6.7'
                            fontWeight="500" 
                            height='4' radius='0.8'
                            hoverColor='#0D968F'
                            hoverBgColor='#ffffff' borderColor='#0D968F'
                        >
                            Save
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}